import cn from 'classnames';
import { IoClose } from 'react-icons/io5';
import ReactModal from 'react-modal';

import modalStyles from './GenericModal.module.scss';

export default function GenericModal({ modal }) {
  const modalClasses = modal.isFullscreen ?
    {
      base: cn(modalStyles.fullScreen, modalStyles.animatedModal, {
        [modal.contentClass]: modal.contentClass,
      }),
      afterOpen: modalStyles['animatedModal--after-open'],
      beforeClose: modalStyles['animatedModal--before-close'],
    }
    : cn({ [modal.contentClass]: modal.contentClass });

  return (
    <ReactModal
      isOpen={modal.isOpen}
      onAfterOpen={modal.afterOpenModal}
      onRequestClose={modal.closeModal}
      style={modal.customStyles}
      contentLabel={modal.label}
      portalClassName={modalStyles.modal}
      overlayClassName={cn({ [modal.overlayClass]: modal.overlayClass })}
      /* if you are using React 16, the close transition works only if
      you use the isOpen prop to toggle the visibility of the modal. */
      closeTimeoutMS={modal.isFullscreen ? 400 : 0}
      className={modalClasses}
      ariaHideApp={false}
    >
      {modal.closeModal && modal.navigation.length > 0 && (
        <div
          className={cn(modalStyles.header, {
            [modal.headerClass]: modal.headerClass,
          })}
        >
          <div>{modal.navigation.map(nav => nav)}</div>
          <button type="button" className={modalStyles.close} onClick={() => modal.closeModal()}>
            {modal.icon ? modal.icon : <IoClose className={modalStyles.closeSymbol} />}
          </button>
        </div>
      )}
      <div
        className={cn(modalStyles.body, {
          [modalStyles[modal.bodyOverwrite]]: modal.bodyOverwrite,
        })}
      >
        {modal.body[modal.view]}
      </div>
      <div className={modalStyles.footer} />
    </ReactModal>
  );
}
